import styled from 'styled-components';
import { Card, Heading, Text, Icon, Input } from '@amzn/storm-ui';

export const CenteredBodyDiv = styled.div`
  width: 840px;
  margin: auto;
  padding: 24px;
`;

export const XLargePaddingTopDiv = styled.div`
  padding-block-start: ${({ theme }) => theme.spacing.large.default};
  background: ${({ theme }) => theme.color.gray[75]};
`;

export const XLargeMarginDiv = styled.div`
  margin: ${({ theme }) => theme.spacing.large.default};
`;

export const MediumMarginDiv = styled.div`
  margin: ${({ theme }) => theme.spacing.base.default};
`;

export const PageTitle = styled(Heading)`
  && {
    text-align: center;
  }
`;

export const PageLoadingSpinnerDiv = styled.div`
  margin: 10% 0% 0% 45%;
`;

export const LayoutTable = styled.table`
  border: none !important; /* stylelint-disable-line declaration-no-important */
  margin: 0 !important; /* stylelint-disable-line declaration-no-important */
`;

export const LayoutTD = styled.td`
  background: white;
  margin: 0 !important; /* stylelint-disable-line declaration-no-important */
  padding: 0 !important; /* stylelint-disable-line declaration-no-important */
`;

export const LayoutTDHeading = styled.td`
  background: white;
  margin: 0 !important; /* stylelint-disable-line declaration-no-important */
  padding: 0 !important; /* stylelint-disable-line declaration-no-important */
  width: 160px;
  vertical-align: top !important; /* stylelint-disable-line declaration-no-important */
`;

export const LayoutTDBody = styled.td`
  background: white;
  margin: 0 !important; /* stylelint-disable-line declaration-no-important */
  padding: 0 !important; /* stylelint-disable-line declaration-no-important */
  width: 620px;
`;

export const LayoutTDBodyCentered = styled.td`
  background: white;
  margin: 0 !important; /* stylelint-disable-line declaration-no-important */
  padding: 0px 0px 0px 175px !important; /* stylelint-disable-line declaration-no-important */
  width: 450px;
`;

export const MarketplaceCard = styled(Card)`
  && {
    background: ${({ theme }) => theme.color.gray[75]};
    width: 168px;
    height: 45px;
    padding: 10px;
    margin: 0px 14px 14px 0px;
    border-radius: 6px;
    display: inline-block;
    &:hover {
      cursor: pointer;
    }
    &[aria-disabled='true']:hover {
      cursor: not-allowed;
    }
  }
`;

export const MarketplaceCheckBoxDiv = styled.div`
  width: 20%;
  display: block;
  float: left; /* stylelint-disable-line */
  position: absolute;
`;

export const MarketplaceCardInnerDiv = styled.div`
  position: relative;
  top: -25px;
  left: -25px;
`;

export const MarketplaceInfoDiv = styled.div`
  width: 70%;
  padding-inline-start: ${({ theme }) => theme.spacing.large.default};
  display: block;
  float: left; /* stylelint-disable-line */
  text-align: start;
  white-space: nowrap;
`;

export const ErrorText = styled(Text)`
  && {
    color: ${({ theme }) => theme.color.red[800]};
  }
`;

export const ErrorIcon = styled(Icon)`
  && {
    color: ${({ theme }) => theme.color.red[800]};
  }
`;

export const InputFieldHeader = styled(Heading)`
  && {
    text-align: end;
    margin-inline-end: ${({ theme }) => theme.spacing.xsmall.default};
  }
`;

export const AccountNameInput = styled(Input)`
  && {
    width: 400px !important; /* stylelint-disable-line declaration-no-important */
  }
`;

export const LargeCard = styled(Card)`
  && {
    width: 840px;
    padding: 0px;
    margin: auto;
  }
`;

export const MiniMarginNoLeftDiv = styled.div`
  margin: ${({ theme }) => theme.spacing.xxsmall.default};
  margin-inline-start: 0px;
`;

export const TextShiftedUp = styled(Text)`
  && {
    margin-block-start: -${({ theme }) => theme.spacing.xxsmall.default};
  }
`;

export const MarketplaceInfoIcon = styled(Icon)`
  && {
    color: ${({ theme }) => theme.color.lightBlue[800]};
  }
`;

export const ContactInfoCard = styled(Card)`
  && {
    background: ${({ theme }) => theme.color.gray[0]};
    width: 400px;
  }
`;

export const RequesterInfoDiv = styled.div`
  display: inline-block;
`;

export const TertiarySpan = styled.span`
  color: ${({ theme }) => theme.color.gray[600]};
  font-size: 12px;
`;

export const AcceptButtonRowContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 35%;
  margin: 0;

  .self-reg-cancel-button {
    margin-inline-start: ${({ theme }) => theme.spacing.xsmall.default};
    margin-inline-end: ${({ theme }) => theme.spacing.xsmall.default};
  }

  .non-endemic-cancel-button {
    margin-inline-start: ${({ theme }) => theme.spacing.xsmall.default};
    margin-inline-end: ${({ theme }) => theme.spacing.xsmall.default};
  }
`;

export const AcceptTextContainer = styled.div`
  display: flex;
  width: 65%;
  margin: 0;
  justify-content: flex-start;
`;

export const MarketplaceExpansion = styled.div`
  background-color: #f3f3f3;
`;
